module.exports = __webpack_public_path__ + "img/b5.db3adc68.png";